<template>
  <b-row>
    <b-col cols="12">
      <h3 class="mb-3 hp-text-color-black-1">Контакты</h3>
    </b-col>

    <b-col cols="12" class="mb-32">
      <b-row>
        <b-col>
          <b-card class="rounded">
            <p class="hp-p1-body">Телефон поддержки</p>
            <b-button
              id="support-phone"
              @click="clipboard(support_phone)"
              variant="text" class="text-black-100 hp-hover-bg-black-10 hp-hover-bg-dark-80 hp-hover-text-color-dark-0"
              size="lg"
              v-b-tooltip.click="'Copied!'"
              >{{ support_phone }}</b-button
            >
          </b-card>
          <b-card class="rounded mt-3">
            <h4>Чем можем вам помочь?</h4>
            <p class="hp-p1-body">
              Возникли трудности? Или есть предложения по улучшению
              пользовательского опыта? Заполните короткую форму и мы с вами
              свяжемся в ближайшее время
            </p>

            <ValidationObserver v-slot="{ valid }">
              <b-form>
                <validation-provider
                  :rules="{
                    required: true,
                    regex:
                      /^(\+7|7|8)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/,
                  }"
                  v-slot="{ dirty, valid, invalid, errors }"
                >
                  <b-form-group
                    id="input-group-tel"
                    label="Телефон:"
                    label-for="input-tel"
                  >
                    <b-form-input
                      id="input-tel"
                      v-model="form.tel"
                      type="tel"
                      placeholder="+7 000 000 0000"
                      v-bind:class="{
                        'is-valid': dirty && valid,
                        'is-invalid': dirty && invalid,
                      }"
                      required
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>

                <validation-provider
                  :rules="{
                    required: true,
                    email: true,
                  }"
                  v-slot="{ dirty, valid, invalid, errors }"
                >
                  <b-form-group
                    id="input-group-email"
                    label="Email:"
                    label-for="input-email"
                  >
                    <b-form-input
                      id="input-email"
                      v-model="form.email"
                      type="email"
                      v-bind:class="{
                        'is-valid': dirty && valid,
                        'is-invalid': dirty && invalid,
                      }"
                      placeholder="example@mail.com"
                      required
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>

                <validation-provider
                  :rules="{
                    required: true,
                  }"
                  v-slot="{ dirty, valid, invalid, errors }"
                >
                  <b-form-group
                    id="input-group-question"
                    label="Ваш вопрос:"
                    label-for="input-question"
                  >
                    <b-form-textarea
                      id="input-question"
                      v-model="form.question"
                      type="text"
                      v-bind:class="{
                        'is-valid': dirty && valid,
                        'is-invalid': dirty && invalid,
                      }"
                      placeholder="Напишите ваш вопрос"
                      required
                    ></b-form-textarea>
                  </b-form-group>
                </validation-provider>

                <b-button
                  :disabled="!valid"
                  type="submit"
                  variant="primary"
                  class="mb-8 mr-8"
                  @click="onSubmit()"
                  >Отправить</b-button
                >
              </b-form>
            </ValidationObserver>
          </b-card>
        </b-col>
        <b-col>
          <b-card class="rounded">
            <p class="hp-p1-body">Наш телеграм</p>
            <a :href="support_telegram_link" class="h4">{{
              support_telegram
            }}</a>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BForm,
  BFormGroup,
  BFormCheckboxGroup,
  BFormCheckbox,
  BFormSelect,
  BFormInput,
  BFormTextarea,
} from "bootstrap-vue";
import axios from "axios";

export default {
  data() {
    return {
      support_phone: process.env.VUE_APP_SUPPORT_PHONE,
      support_telegram: process.env.VUE_APP_SUPPORT_TELEGRAM,
      support_telegram_link: process.env.VUE_APP_SUPPORT_TELEGRAM_LINK,
      form: {
        tel: "",
        email: "",
        question: "",
      },
    };
  },
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BFormCheckboxGroup,
    BFormCheckbox,
    BFormSelect,
    BFormInput,
    BFormTextarea,
  },
  methods: {
    clipboard(text) {
      const root = this.$root;
      setTimeout(function () {
        root.$emit('bv::hide::tooltip');
      }, 800);
      var input = document.createElement("input");
      input.setAttribute("value", text);
      input.className = "hidden";

      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
    },
    onSubmit() {
      axios
        .post(
          `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/ask_question`,
          {
            tel: this.form.tel,
            email: this.form.email,
            question: this.form.question,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then(function (response) {
          console.log(response);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
